import React from 'react';

const AutoSearchResults = (props) => {
    const { listItem, unorderedList } = styles;

    return (
        <ul hidden={!props.matchingSearchValues.length} style={unorderedList}>
            {
                props.matchingSearchValues.map((searchValue, i) => {

                    if (searchValue.brandName && props.comparisonValue && searchValue.brandName !== props.comparisonValue) {
                        return null;
                    }

                    return (
                        <li
                            className='autoCompleteSearchItem'
                            key={`${props.inputName}-${i}`}
                            style={listItem}
                            onClick={() => props.selectElement(searchValue)}
                        >
                            <p style={{ margin: 0 }}>{searchValue[props.inputName]}</p>
                            {
                                props.inputName === 'restaurantName' && <span style={{ color: '#a9a9a9' }}>{searchValue.brandName}</span>
                            }
                        </li>
                    );
                })
            }
        </ul>
    );
}

export default AutoSearchResults;


const styles = {
    unorderedList: {
        display: 'inline-block',
        width: 'calc(100% - 5px)',
        paddingLeft: 0,
        zIndex: 10,
        overflow: 'auto',
        position: 'absolute',
        listStyle: 'none',
        maxHeight: 250,
        background: '#F8F8F8',
        border: '1px solid #ced4da',
        borderRadius: 0,
        top: 50
    },
    listItem: {
        width: '100%',
        padding: 6,
        zIndex: 11
    }
}


// WEBPACK FOOTER //
// ./src/components/central/autosearch/AutoSearchResults.js